import { Check } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const IMG = "https://static.prod-images.emergentagent.com/jobs/aac30769-f491-4e91-84b6-42abbea5b108/images/480ed47abb8837de4d45868c027f49c82d0159dab0458873a2209c646b6a7ef8.jpeg";

export const Certification = ({ t }) => (
  <section
    id="certification"
    data-testid="cert-value-section"
    className="relative z-10 py-24 md:py-32 bg-[#050505]"
  >
    <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <Reveal className="order-2 lg:order-1">
        <Overline testId="cert-overline">{t.certification.overline}</Overline>
        <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight">
          {t.certification.title}
        </h2>
        <p className="text-white/60 text-lg leading-relaxed mt-8">
          {t.certification.text}
        </p>
        <ul className="mt-10 space-y-4">
          {t.certification.bullets.map((b, i) => (
            <li key={i} className="flex items-start gap-4">
              <span className="mt-1 w-5 h-5 shrink-0 flex items-center justify-center bg-[#D4AF37] text-black">
                <Check size={13} strokeWidth={3} />
              </span>
              <span className="text-white/80">{b}</span>
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal delay={0.15} className="order-1 lg:order-2">
        <div className="relative">
          <div className="absolute -top-4 -left-4 w-full h-full border border-[#D4AF37]/30" />
          <img
            src={IMG}
            alt="Luxury business handshake over a wooden table"
            className="relative w-full h-[420px] md:h-[520px] object-cover grayscale-[20%]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        </div>
      </Reveal>
    </div>
  </section>
);
